"use strict"; // Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Exports_1 = require("../common.browser/Exports");

var Exports_2 = require("../common.speech/Exports");

var Exports_3 = require("../sdk/Exports");

var Exports_4 = require("./Exports");

var QueryParameterNames_1 = require("./QueryParameterNames");

var SpeechConnectionFactory =
/** @class */
function () {
  function SpeechConnectionFactory() {
    var _this = this;

    this.interactiveRelativeUri = "/speech/recognition/interactive/cognitiveservices/v1";
    this.conversationRelativeUri = "/speech/recognition/conversation/cognitiveservices/v1";
    this.dictationRelativeUri = "/speech/recognition/dictation/cognitiveservices/v1";

    this.create = function (config, authInfo, connectionId) {
      var endpoint = config.parameters.getProperty(Exports_3.PropertyId.SpeechServiceConnection_Endpoint, undefined);
      var queryParams = {};
      var endpointId = config.parameters.getProperty(Exports_3.PropertyId.SpeechServiceConnection_EndpointId, undefined);
      var language = config.parameters.getProperty(Exports_3.PropertyId.SpeechServiceConnection_RecoLanguage, undefined);

      if (endpointId) {
        if (!endpoint || endpoint.search(QueryParameterNames_1.QueryParameterNames.DeploymentIdParamName) === -1) {
          queryParams[QueryParameterNames_1.QueryParameterNames.DeploymentIdParamName] = endpointId;
        }
      } else if (language) {
        if (!endpoint || endpoint.search(QueryParameterNames_1.QueryParameterNames.LanguageParamName) === -1) {
          queryParams[QueryParameterNames_1.QueryParameterNames.LanguageParamName] = language;
        }
      }

      if (!endpoint || endpoint.search(QueryParameterNames_1.QueryParameterNames.FormatParamName) === -1) {
        queryParams[QueryParameterNames_1.QueryParameterNames.FormatParamName] = config.parameters.getProperty(Exports_2.OutputFormatPropertyName, Exports_3.OutputFormat[Exports_3.OutputFormat.Simple]).toLowerCase();
      }

      if (!endpoint) {
        var region = config.parameters.getProperty(Exports_3.PropertyId.SpeechServiceConnection_Region, undefined);
        var host = "wss://" + region + ".stt.speech.microsoft.com";

        switch (config.recognitionMode) {
          case Exports_4.RecognitionMode.Conversation:
            endpoint = host + _this.conversationRelativeUri;
            break;

          case Exports_4.RecognitionMode.Dictation:
            endpoint = host + _this.dictationRelativeUri;
            break;

          default:
            endpoint = host + _this.interactiveRelativeUri; // default is interactive

            break;
        }
      }

      var headers = {};
      headers[authInfo.headerName] = authInfo.token;
      headers[QueryParameterNames_1.QueryParameterNames.ConnectionIdHeader] = connectionId;
      return new Exports_1.WebsocketConnection(endpoint, queryParams, headers, new Exports_4.WebsocketMessageFormatter(), Exports_1.ProxyInfo.fromRecognizerConfig(config), connectionId);
    };
  }

  return SpeechConnectionFactory;
}();

exports.SpeechConnectionFactory = SpeechConnectionFactory;